import {Moment} from 'moment';
import {Currency, ToggleProperty} from 'types';
import {CourseObject, TeacherObject} from 'api/course';

export enum DateFormat {
  DayMonth = 'DD MMMM',
  Date = 'DD MMMM YYYY',
  Dot = 'DD.MM.YYYY',
  Full = 'HH:MM DD.MM.YYYY',
}

export interface ICoursePromoContext {
  title: string;

  description: string;

  preview: CoursePromoPreview,

  giftCourses?: CourseGifts,

  prices: Prices,

  chapters: ChapterItem[],

  contentCounters: ContentCounters,

  targetAudience: TargetAudience,

  benefit: Benefit,

  author: Author,

  teachers: TeacherItem[],

  questions: Questions,

  daysAccessCount: number,

  dates: Dates,
}

export interface CourseGifts {
  title: string;
  items: CourseGiftItem[];
}

export interface CourseGiftItem {
  id: CourseObject['id'],
  title: string,
  cover: string,
  link: string,
}

export interface TargetAudience {
  title: string,
  items: TargetAudienceItem[]
}

export interface TargetAudienceItem {
  title: string;
  description?: string;
  preview?: string;
}

export interface Benefit {
  title: string;
  items: string[];
}

export type ChapterItem = string;

export interface ContentCounters {
  lessons: number;
  tasks: number;
  webinars: number;
}

export interface Author {
  name: string;
  message: string;
  preview: string;
  role: string;
  video: string;
}

export interface CoursePromoPreview {
  cover: string;
  video?: string;
}

export interface Prices {
  currency: Currency,
  old?: number;
  current: number;
  discountSeats?: number;
  discountEndDate?: Moment ;
  isInstallmentAvailable?: boolean;
}

export interface TeacherItem extends TeacherObject {
  imgSrc: string,
}

export interface Questions {
  title: string;
  items: QuestionItem[];
}

export interface QuestionItem {
  question: string;
  answer: string;
}

export interface Dates extends ToggleProperty {
  start: Moment,
  end?: Moment,
  duration?: number,
}
